export default "__VITE_ASSET__246d9be2__"